import { render } from "./IncidentDetailView.vue?vue&type=template&id=a93e2598&scoped=true&ts=true"
import script from "./IncidentDetailView.vue?vue&type=script&lang=ts"
export * from "./IncidentDetailView.vue?vue&type=script&lang=ts"

import "./IncidentDetailView.vue?vue&type=style&index=0&id=a93e2598&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a93e2598"]])

export default __exports__